import uniqBy from 'lodash/uniqBy';
import FaqSearch from '@/services/faq/faqService/FaqSearch';
import FaqAnswers from '@/services/faq/faqService/FaqAnswers';
import FaqCategories from '@/services/faq/faqService/FaqCategories';
import FaqPayment from '@/services/faq/faqService/pages/FaqPayment';
import FaqDelivery from '@/services/faq/faqService/pages/FaqDelivery';
import FaqIntroductions from '@/services/faq/faqService/pages/FaqIntroductions';

export default class FaqService {
    /**
     * Get all FAQs categories.
     *
     * @return {Promise}
     */
    getCategories() {
        return (new FaqCategories()).handle();
    }

    /**
     * Get all FAQs answers.
     *
     * @return {Promise}
     */
    getQuestions() {
        return (new FaqAnswers()).handle();
    }

    /**
     * Get all unique FAQs answers from all categories.
     *
     * @return {Array}
     */
    async getUniqQuestions() {
        let questions = [];

        await this.getQuestions().then((response) => {
            questions = response;
        });

        return uniqBy(questions, (answer) => [answer.title, answer.loggedIn].join());
    }

    /**
     * Get unique FAQs answers for default search input.
     *
     * @return {Promise}
     */
    getSearchQuestions() {
        return (new FaqSearch()).handle();
    }

    /**
     * Get FAQs answers for the given path.
     *
     * @param {String} path
     *
     * @return {Promise}
     */
    getAnswersByPath(path) {
        return (new FaqAnswers()).findAnswersByPath(path);
    }

    /**
     * Find category object by path.
     *
     * @param {String} path
     *
     * @return {Promise}
     */
    getCategoryByPath(path) {
        return (new FaqCategories()).findCategoryByPath(path);
    }

    /**
     * Get the payment questions.
     *
     * @return {Array}
     */
    async getPaymentQuestions() {
        let questions = [];

        await (new FaqPayment()).handle().then((response) => {
            questions = response;
        });

        return questions;
    };

    /**
     * Get the delivery questions.
     *
     * @return {Array}
     */
    async getDeliveryQuestions() {
        let questions = [];

        await (new FaqDelivery()).handle().then((response) => {
            questions = response;
        });

        return questions;
    };

    /**
     * Get the introduction questions.
     *
     * @return {Array}
     */
    async getIntroductionsQuestions() {
        let questions = [];

        await (new FaqIntroductions()).handle().then((response) => {
            questions = response;
        });

        return questions;
    }
}
